const React = require('react');
const PropTypes = require('prop-types');
const { useTranslation } = require('react-i18next');
const { Button } = require('stremio/components');
const getMetaDetailsHref = require('stremio/common/getMetaDetailsHref').default;
const { trailerPlayerLink } = require('stremio/caroline/playback/playerRoutes');
const styles = require('./BoardHero.less');

const BoardHero = ({ item }) => {
    const { t } = useTranslation();
    if (!item) return null;

    const detailsHref = getMetaDetailsHref(item.deepLinks, true);
    const trailer = item.trailerStreams?.find(({ ytId }) => typeof ytId === 'string' && ytId.length > 0);
    const trailerHref = trailer ? trailerPlayerLink({ type: item.type, id: item.id, ytId: trailer.ytId }) : null;
    const playHref = trailerHref || getMetaDetailsHref(item.deepLinks);
    const playLabel = trailerHref ? t('WATCH_TRAILER') : t('PLAYER_PLAY');
    const meta = [item.releaseInfo, item.runtime].filter((value) => typeof value === 'string' && value.trim()).join(' · ');

    return (
        <section className={styles['hero']} aria-label={item.name}>
            {item.background || item.poster ? (
                <img className={styles['backdrop']} src={item.background || item.poster} alt={''} />
            ) : null}
            <div className={styles['content']}>
                {meta ? <div className={styles['metadata']}>{meta}</div> : null}
                <h1 className={styles['title']}>{item.name}</h1>
                {typeof item.description === 'string' && item.description.trim() ? (
                    <p className={styles['description']}>{item.description}</p>
                ) : null}
                <div className={styles['actions']}>
                    {typeof playHref === 'string' ? (
                        <Button className={styles['primary-action']} href={playHref}>{playLabel}</Button>
                    ) : null}
                    {typeof detailsHref === 'string' ? (
                        <Button className={styles['secondary-action']} href={detailsHref}>{t('MORE_INFO')}</Button>
                    ) : null}
                </div>
            </div>
        </section>
    );
};

BoardHero.propTypes = {
    item: PropTypes.shape({
        name: PropTypes.string,
        background: PropTypes.string,
        poster: PropTypes.string,
        releaseInfo: PropTypes.string,
        runtime: PropTypes.string,
        description: PropTypes.string,
        deepLinks: PropTypes.object,
        type: PropTypes.string,
        id: PropTypes.string,
        trailerStreams: PropTypes.arrayOf(PropTypes.shape({
            deepLinks: PropTypes.shape({ player: PropTypes.string }),
        })),
    }),
};

module.exports = BoardHero;
